import { useCallback, useRef, useState } from 'react';

// The ref blocks repeated actions even before React renders the disabled button.
export default function usePendingState(initialValue = false) {
    const [pending, setPending] = useState(initialValue);
    const pendingRef = useRef(initialValue);
    const updatePending = useCallback((value) => {
        pendingRef.current = value;
        setPending(value);
    }, []);

    return [pending, updatePending, pendingRef];
}
